"use strict";
export const GroupsMock = (mock) => {
  mock.onGet("/v7/groups").reply((config) => {
    let _response = {
      "model": "groups",
      "tabs": {
        "model": "data.set",
        "datas": [
          {
            "model": "group",
            "id": "vdgroup_system_all",
            "name": "\u5168\u90E8",
            "type": "system",
            "source": "/api/v3/virtual_desktops/groups",
            "prames": {
              "group_guid": "vdgroup_system_all"
            },
            "marks": {
              "model": "tags",
              "tags": [
                "DEFAULT_SELECTED"
              ]
            }
          },
          {
            "model": "group",
            "id": "vdgroup_system_often",
            "name": '<span slot="label"><i class="el-icon-star-on"></i>\u5E38\u7528</span>',
            "type": "system",
            "source": "/api/v3/virtual_desktops/favorites",
            "prames": {
              "group_guid": "vdgroup_system_often"
            },
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          {
            "model": "group",
            "id": "vdgroup_709f7f919c994421907cbdf8b4f82bc1",
            "name": "1",
            "type": "custom",
            "source": "/api/v3/virtual_desktops/groups",
            "prames": {
              "group_guid": "vdgroup_709f7f919c994421907cbdf8b4f82bc1"
            },
            "marks": {
              "model": "tags",
              "tags": []
            }
          },
          {
            "model": "group",
            "id": "vdgroup_3f2ca43dded14c87aa94e13dbe53a20f",
            "name": "2",
            "type": "custom",
            "source": "/api/v3/virtual_desktops/groups",
            "prames": {
              "group_guid": "vdgroup_3f2ca43dded14c87aa94e13dbe53a20f"
            },
            "marks": {
              "model": "tags",
              "tags": []
            }
          }
        ],
        "total": 4
      }
    };
    return [200, _response];
  });
};
